let macThemeObject,
  getParseObject,
  getmacThemeObject,
  ParsedObject,
  ifStarterKit;

export const windowLoad = function () {
  window.addEventListener('load', function () {
    // Remove Loader
    const load_screen = document.getElementById('load_screen');
    document.body.removeChild(load_screen);
    const logoImg = document.querySelectorAll('.navbar-logo');

    const layoutName = 'Dark Menu';

    const settingsObject = {
      admin: 'Mac Task App',
      settings: {
        layout: {
          name: layoutName,
          toggle: true,
          darkMode: true,
          boxed: false,
          logo: {
            darkLogo: logoImg[0].getAttribute('src'),
            lightLogo: logoImg[0].getAttribute('src'),
          },
        },
      },
      reset: false,
    };

    if (settingsObject.reset) {
      localStorage.clear();
    }

    if (localStorage.length === 0) {
      macThemeObject = settingsObject;
    } else {
      getmacThemeObject = localStorage.getItem('theme');
      getParseObject = JSON.parse(getmacThemeObject);
      ParsedObject = getParseObject;

      if (getmacThemeObject !== null) {
        if (ParsedObject.admin === 'Mac Task App') {
          if (ParsedObject.settings.layout.name === layoutName) {
            macThemeObject = ParsedObject;
          } else {
            macThemeObject = settingsObject;
          }
        } else {
          if (ParsedObject.admin === undefined) {
            macThemeObject = settingsObject;
          }
        }
      } else {
        macThemeObject = settingsObject;
      }
    }

    // Get Dark Mode Information i.e darkMode: true or false

    if (macThemeObject.settings.layout.darkMode) {
      localStorage.setItem('theme', JSON.stringify(macThemeObject));
      getmacThemeObject = localStorage.getItem('theme');
      getParseObject = JSON.parse(getmacThemeObject);

      if (getParseObject.settings.layout.darkMode) {
        ifStarterKit =
          document.body.getAttribute('page') === 'starter-pack' ? true : false;
        document.body.classList.add('dark');
        if (ifStarterKit) {
          if (document.querySelector('.navbar-logo')) {
            document
              .querySelector('.navbar-logo')
              .setAttribute('src', './src/assets/img/logo.svg');
          }
        } else {
          if (document.querySelector('.navbar-logo')) {
            document
              .querySelector('.navbar-logo')
              .setAttribute(
                'src',
                getParseObject.settings.layout.logo.darkLogo
              );
          }
        }
      }
    } else {
      localStorage.setItem('theme', JSON.stringify(macThemeObject));
      getmacThemeObject = localStorage.getItem('theme');
      getParseObject = JSON.parse(getmacThemeObject);

      if (!getParseObject.settings.layout.darkMode) {
        ifStarterKit =
          document.body.getAttribute('page') === 'starter-pack' ? true : false;
        document.body.classList.remove('dark');
        if (ifStarterKit) {
          if (document.querySelector('.navbar-logo')) {
            document
              .querySelector('.navbar-logo')
              .setAttribute('src', './src/assets/img/logo2.svg');
          }
        } else {
          if (document.querySelector('.navbar-logo')) {
            document
              .querySelector('.navbar-logo')
              .setAttribute(
                'src',
                getParseObject.settings.layout.logo.lightLogo
              );
          }
        }
      }
    }

    // Get Layout Information i.e boxed: true or false

    if (macThemeObject.settings.layout.boxed) {
      localStorage.setItem('theme', JSON.stringify(macThemeObject));
      getmacThemeObject = localStorage.getItem('theme');
      getParseObject = JSON.parse(getmacThemeObject);

      if (getParseObject.settings.layout.boxed) {
        if (document.body.getAttribute('layout') !== 'full-width') {
          document.body.classList.add('layout-boxed');
          if (document.querySelector('.header-container')) {
            // document.querySelector('.header-container').classList.add('container-xxl');
          }
          if (document.querySelector('.middle-content')) {
            document
              .querySelector('.middle-content')
              .classList.add('container-xxl');
          }
        } else {
          document.body.classList.remove('layout-boxed');
          if (document.querySelector('.header-container')) {
            document
              .querySelector('.header-container')
              .classList.remove('container-xxl');
          }
          if (document.querySelector('.middle-content')) {
            document
              .querySelector('.middle-content')
              .classList.remove('container-xxl');
          }
        }
      }
    } else {
      localStorage.setItem('theme', JSON.stringify(macThemeObject));
      getmacThemeObject = localStorage.getItem('theme');
      getParseObject = JSON.parse(getmacThemeObject);

      if (!getParseObject.settings.layout.boxed) {
        if (document.body.getAttribute('layout') !== 'boxed') {
          document.body.classList.remove('layout-boxed');
          if (document.querySelector('.header-container')) {
            document
              .querySelector('.header-container')
              .classList.remove('container-xxl');
          }
          if (document.querySelector('.middle-content')) {
            document
              .querySelector('.middle-content')
              .classList.remove('container-xxl');
          }
        } else {
          document.body.classList.add('layout-boxed');
          if (document.querySelector('.header-container')) {
            // document.querySelector('.header-container').classList.add('container-xxl');
          }
          if (document.querySelector('.middle-content')) {
            document
              .querySelector('.middle-content')
              .classList.add('container-xxl');
          }
        }
      }
    }
  });
};
